if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      if (this.querySelector('form')) {
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      else {
        this.querySelector('[name=id]').disabled = false;
        this.querySelector('button[type=submit]').addEventListener('click', this.onSubmitHandler.bind(this));
      }
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      const quantityInput = this.form ? this.form.querySelector('[name=quantity]') : this.querySelector('[name=quantity]');
      const quantityToAdd = quantityInput ? (parseInt(quantityInput.value, 10) || 1) : 1;
      this.updateCartCountOptimistic(quantityToAdd);

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (!this.form) {
        formData.append('id', this.querySelector('[name=id]').value);
      }
      
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.rollbackCartCount();
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          this.rollbackCartCount();
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    updateCartCountOptimistic(quantityToAdd = 1) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;

      const countBubble = cartIconBubble.querySelector('.cart-count-bubble');
      if (!countBubble) return;

      const countSpan = countBubble.querySelector('span[aria-hidden="true"]');
      let currentCount = 0;
      if (countSpan && countSpan.textContent) {
        const matches = countSpan.textContent.match(/\d+/);
        if (matches) currentCount = parseInt(matches[0], 10) || 0;
      } else if (countBubble.textContent) {
        const matches = countBubble.textContent.match(/\d+/);
        if (matches) currentCount = parseInt(matches[0], 10) || 0;
      }

      this.previousCartCount = currentCount;
      const newCount = currentCount + quantityToAdd;

      if (countSpan) {
        countSpan.textContent = `(${newCount})`;
      } else {
        countBubble.innerHTML = `<span aria-hidden="true">(${newCount})</span><span class="visually-hidden">${newCount}</span>`;
      }

      try {
        localStorage.setItem('cart_count', newCount.toString());
        localStorage.setItem('cart_timestamp', Date.now().toString());
      } catch (e) {}
    }

    rollbackCartCount() {
      if (typeof this.previousCartCount !== 'number') return;
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (!cartIconBubble) return;

      const countBubble = cartIconBubble.querySelector('.cart-count-bubble');
      if (!countBubble) return;

      const countSpan = countBubble.querySelector('span[aria-hidden="true"]');
      if (countSpan) {
        countSpan.textContent = `(${this.previousCartCount})`;
      }

      try {
        localStorage.setItem('cart_count', this.previousCartCount.toString());
        localStorage.setItem('cart_timestamp', Date.now().toString());
      } catch (e) {}
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
